import React, { useState } from "react";
import { Button } from "@mui/material";
import OrganisationMemberRoleDialog from "../Dialogs/OrganisationMemberRoleDialog";

const EditMemberRoleButton = ({ organisationId, userId }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleOpen}>
        Edit Role
      </Button>

      <OrganisationMemberRoleDialog
        open={open}
        handleClose={handleClose}
        organisationId={organisationId}
        userId={userId}
      />
    </>
  );
};

export default EditMemberRoleButton;
